import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Error = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="error icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M28.5359 6C30.0755 3.33333 33.9245 3.33333 35.4641 6L62.5359 52.8897C64.0755 55.5564 62.151 58.8897 59.0718 58.8897H4.92821C1.84901 58.8897 -0.0754933 55.5564 1.46411 52.8897L28.5359 6Z"
      className={`color-iconNotify-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.9378 54.3897L32.866 7.5C32.4811 6.83333 31.5189 6.83333 31.134 7.5L4.06218 54.3897C3.67728 55.0564 4.15841 55.8897 4.92821 55.8897H59.0718C59.8416 55.8897 60.3227 55.0564 59.9378 54.3897ZM35.4641 6C33.9245 3.33333 30.0755 3.33333 28.5359 6L1.46411 52.8897C-0.0754933 55.5564 1.84901 58.8897 4.92821 58.8897H59.0718C62.151 58.8897 64.0755 55.5564 62.5359 52.8897L35.4641 6Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M34.9167 27.6667C34.9167 26.0558 33.6109 24.75 32 24.75C30.3892 24.75 29.0834 26.0558 29.0834 27.6667V38.75C29.0834 40.3608 30.3892 41.6667 32 41.6667C33.6109 41.6667 34.9167 40.3608 34.9167 38.75V27.6667Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M32 49.25C33.6109 49.25 34.9167 47.9442 34.9167 46.3333C34.9167 44.7225 33.6109 43.4167 32 43.4167C30.3892 43.4167 29.0834 44.7225 29.0834 46.3333C29.0834 47.9442 30.3892 49.25 32 49.25Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
